import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { TraceContext } from "./TraceContext";

export { TraceContext }
export const traceContext = new TraceContext();

export function UseTraceContext(instance: AxiosInstance, traceContext: TraceContext): AxiosInstance {
    instance.interceptors.request.use((config: AxiosRequestConfig) => {
        config.headers[traceContext.traceParentHeaderName] = traceContext.traceParentHeader;

        return config;
    });

    return instance;
}